export const TYPE_USER = 'Account_User';
export const TYPE_ORGANIZATION = 'Account_Organization';
export const TYPE_TEAM = 'Account_Team';
